// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.integrations-page-content.integrations-page-content {
  width: min(1060px, calc(100% - 56px));
  min-height: 100%;
  margin: 0 auto;
  padding: 64px 0 96px;
  box-sizing: border-box;
  color: var(--color-text-primary);
  background: var(--color-bg-root);
}

.integrations-page-content .integrations-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  margin-bottom: 46px;
}

.integrations-page-content .integrations-page-header-left {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.integrations-page-content .integrations-page-title {
  margin: 0;
  color: var(--color-text-primary);
  font-size: 29px;
  font-weight: 650;
  line-height: 1.08;
  letter-spacing: -0.04em;
}

.integrations-page-content .integrations-page-subtitle {
  max-width: 560px;
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 14px;
  line-height: 1.5;
}

.integrations-error,
.integrations-pending {
  display: flex;
  align-items: center;
  gap: 9px;
  margin: -24px 0 30px;
  padding: 11px 14px;
  border: 1px solid;
  border-radius: 10px;
  font-size: 12.5px;
  line-height: 1.45;
}

.integrations-error {
  border-color: var(--color-status-error-border);
  background: var(--color-status-error-tint);
  color: var(--color-status-error-text);
}

.integrations-pending {
  border-color: var(--color-status-success-border);
  background: var(--color-status-success-tint);
  color: var(--color-status-success-text);
}

.integrations-connected {
  margin-bottom: 46px;
}

.integrations-connected-heading {
  display: flex;
  align-items: baseline;
  gap: 9px;
  margin-bottom: 14px;
}

.integrations-connected-heading h2,
.integrations-section-heading h2 {
  margin: 0;
  color: var(--color-text-primary);
  font-size: 15px;
  font-weight: 650;
  letter-spacing: -0.01em;
}

.integrations-connected-heading span {
  color: var(--color-text-secondary);
  font-size: 11.5px;
}

.integrations-connected-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.integrations-connected-icon {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border: 1px solid color-mix(in srgb, var(--color-border-input) 70%, transparent);
  border-radius: 12px;
  color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
}

.integrations-section-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin: 50px 0 13px;
}

.integrations-section-heading--first {
  margin-top: 0;
}

.integrations-section-heading > div:first-child {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.integrations-section-heading p {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 12.5px;
  line-height: 1.45;
}

.integrations-page-content .integrations-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: 8px 42px;
  margin-top: 0;
}

.integrations-card {
  min-width: 0;
  padding: 13px 12px;
  box-sizing: border-box;
  border: 1px solid transparent;
  border-radius: 12px;
  background: transparent;
  transition: border-color 150ms ease, background 150ms ease;
}

.integrations-card:hover {
  border-color: color-mix(in srgb, var(--color-border-input) 62%, transparent);
  background: color-mix(in srgb, var(--color-bg-canvas-surface) 66%, transparent);
}

.integrations-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
}

.integrations-card-summary {
  min-width: 0;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1 auto;
  border: 0;
  outline: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.integrations-card-summary:disabled {
  opacity: 1;
  cursor: default;
}

.integrations-card-summary:focus-visible {
  border-radius: 9px;
  box-shadow: 0 0 0 3px var(--color-focus-ring);
}

.integrations-card-chevron {
  flex: 0 0 auto;
  color: var(--color-text-secondary);
  transition: transform 180ms ease;
}

.integrations-card-chevron.is-expanded {
  transform: rotate(180deg);
}

.integrations-card-logo {
  position: relative;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border-radius: 12px;
  color: #fff;
  box-sizing: border-box;
}

.integrations-card-logo-status {
  position: absolute;
  top: -5px;
  right: -5px;
  min-width: 19px;
  height: 19px;
  padding: 0 4px;
  display: grid;
  place-items: center;
  box-sizing: border-box;
  border: 2px solid var(--color-bg-root);
  border-radius: 999px;
  background: #e5484d;
  color: #fff;
  box-shadow: 0 1px 4px rgba(144, 18, 24, 0.28);
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
}

.integrations-card-logo--tiktok,
.integrations-card-logo--x {
  border: 1px solid #333;
  background: #050505;
}

.integrations-card-logo--instagram {
  background: linear-gradient(45deg, #f09433, #e6683c 25%, #dc2743 50%, #cc2366 75%, #8f24ba);
}

.integrations-card-logo--facebook {
  background: #1877f2;
}

.integrations-card-logo--meta {
  background: #0866ff;
}

.integrations-card-logo--youtube {
  background: #ff0033;
}

.integrations-card-logo--slack {
  border: 1px solid #dedede;
  background: #fff;
}

.integrations-card-heading {
  min-width: 0;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  gap: 2px;
}

.integrations-card-title {
  margin: 0;
  overflow: hidden;
  color: var(--color-text-primary);
  font-size: 13.5px;
  font-weight: 620;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrations-card-desc {
  display: -webkit-box;
  margin: 0;
  overflow: hidden;
  color: var(--color-text-secondary);
  font-size: 12px;
  line-height: 1.35;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.integrations-card-connect {
  width: 34px;
  height: 34px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex: 0 0 auto;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--color-text-primary);
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 150ms ease, color 150ms ease, opacity 150ms ease;
}

.integrations-card-connect:hover:not(:disabled) {
  background: var(--color-bg-input);
}

.integrations-card-connect:disabled {
  opacity: 0.42;
  cursor: default;
}

.integrations-account-list,
.slack-agent-installation-list {
  display: flex;
  flex-direction: column;
  margin: 12px 0 0 56px;
  border-top: 1px solid var(--color-border-sidebar);
}

.integrations-card-dropdown,
.integrations-account-list--dropdown {
  animation: integrations-dropdown-in 170ms ease-out;
  transform-origin: top center;
}

.integrations-social-dropdown {
  margin: 12px 0 0 56px;
  border-top: 1px solid var(--color-border-sidebar);
}

.integrations-social-dropdown .integrations-account-list {
  margin: 0;
  border-top: 0;
}

.integrations-social-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 2px;
  border-bottom: 1px solid var(--color-border-sidebar);
}

.integrations-social-actions > span {
  color: var(--color-text-secondary);
  font-size: 10.5px;
  font-weight: 600;
}

.integrations-social-actions button {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 0;
  background: transparent;
  color: var(--color-text-secondary);
  font: inherit;
  font-size: 10.5px;
  cursor: pointer;
}

.integrations-social-actions button:hover:not(:disabled) {
  color: var(--color-text-primary);
}

.integrations-social-actions button:disabled {
  opacity: 0.5;
  cursor: default;
}

@keyframes integrations-dropdown-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.integrations-account-row,
.slack-agent-installation-row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  padding: 10px 2px;
  border-bottom: 1px solid var(--color-border-sidebar);
}

.integrations-account-row:last-child,
.slack-agent-installation-row:last-child {
  border-bottom: 0;
}

.integrations-account-avatar {
  width: 30px;
  height: 30px;
  flex: 0 0 auto;
  border-radius: 50%;
  object-fit: cover;
}

.integrations-account-avatar--fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 700;
}

.integrations-account-info {
  min-width: 0;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  gap: 1px;
}

.integrations-account-username {
  overflow: hidden;
  color: var(--color-text-primary);
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.integrations-account-status {
  color: var(--color-text-secondary);
  font-size: 10.5px;
}

.integrations-account-status--connected {
  color: var(--color-status-success-text);
}

.integrations-account-status--disconnected {
  color: var(--color-status-error-text);
}

.integrations-account-status--warning {
  color: #b76a00;
}

.integrations-account-remove {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
}

.integrations-account-remove:hover:not(:disabled) {
  background: var(--color-status-error-tint);
  color: var(--color-status-error-text);
}

.integrations-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 24px 12px;
  color: var(--color-text-secondary);
  font-size: 12.5px;
}

.slack-agent-card {
  min-height: auto;
}

.slack-agent-card code {
  padding: 2px 5px;
  border-radius: 5px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 10.5px;
}

.integrations-ad-identity .integrations-card-connect,
.integrations-ad-policy > .integrations-card-connect {
  width: auto;
  min-width: 34px;
  padding: 0 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  background: var(--color-bg-canvas-surface);
}

.slack-agent-dropdown .slack-agent-installation-list {
  margin: 0;
  border-top: 0;
}

.integrations-ad-empty {
  margin: 12px 0 0 56px;
  color: var(--color-text-secondary);
  font-size: 11.5px;
  line-height: 1.45;
}

.slack-agent-loading {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 13px 0 0 56px;
  color: var(--color-text-secondary);
  font-size: 11.5px;
}

.slack-agent-installation-row {
  justify-content: space-between;
}

.slack-agent-installation-main {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.slack-agent-installation-main > div {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.slack-agent-installation-main strong {
  color: var(--color-text-primary);
  font-size: 12px;
}

.slack-agent-installation-main span {
  font-size: 10.5px;
}

.slack-agent-workspace-avatar {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 50%;
  background: var(--color-bg-input);
  color: var(--color-text-secondary) !important;
  font-size: 12px !important;
  font-weight: 800;
}

.slack-agent-installation-actions,
.integrations-ad-status > div {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.slack-agent-installation-actions button,
.integrations-ad-status button {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 0;
  background: transparent;
  color: var(--color-text-secondary);
  font: inherit;
  font-size: 10.5px;
  cursor: pointer;
}

.slack-agent-installation-actions button.is-danger,
.integrations-ad-status button.is-danger {
  color: var(--color-status-error-text);
}

.slack-agent-disconnect {
  width: 28px;
  height: 28px;
  padding: 0;
  justify-content: center;
  border-radius: 7px !important;
}

.slack-agent-disconnect:hover:not(:disabled) {
  background: var(--color-status-error-tint);
}

.integrations-card--ads {
  min-height: 70px;
}

.integrations-ad-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 12px 0 0 56px;
  padding-top: 10px;
  border-top: 1px solid var(--color-border-sidebar);
}

.integrations-ad-identity {
  margin: 12px 0 0 56px;
  color: var(--color-text-secondary);
  font-size: 11px;
}

.integrations-ad-identity > summary {
  cursor: pointer;
  font-weight: 600;
}

.integrations-ad-identity label {
  display: grid;
  gap: 4px;
  margin-top: 9px;
}

.integrations-ad-identity input,
.integrations-ad-policy__limits input {
  min-height: 34px;
  padding: 6px 9px;
  box-sizing: border-box;
  border: 1px solid var(--color-border-input);
  border-radius: 7px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font: inherit;
}

.integrations-ad-identity .integrations-card-connect {
  margin-top: 9px;
}

.integrations-ad-policy {
  display: grid;
  gap: 12px;
  margin-top: 22px;
  padding: 18px;
  border: 1px solid var(--color-border-input);
  border-radius: 12px;
  background: color-mix(in srgb, var(--color-bg-canvas-surface) 72%, transparent);
  color: var(--color-text-primary);
}

.integrations-ad-policy > div:first-child {
  display: grid;
  gap: 3px;
}

.integrations-ad-policy > div:first-child span,
.integrations-ad-policy__limits label {
  color: var(--color-text-secondary);
  font-size: 11px;
}

.integrations-ad-policy__toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.integrations-ad-policy__limits {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 12px;
}

.integrations-ad-policy__limits > div,
.integrations-ad-policy__limits label {
  display: grid;
  gap: 5px;
}

.integrations-ad-policy > .integrations-card-connect {
  justify-self: start;
}

.integrations-spin {
  animation: integrations-spin 0.9s linear infinite;
}

@keyframes integrations-spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 900px) {
  .integrations-page-content.integrations-page-content {
    width: min(720px, calc(100% - 40px));
    padding-top: 42px;
  }

  .integrations-page-content .integrations-grid {
    grid-template-columns: 1fr;
    gap: 6px;
  }
}

@media (max-width: 700px) {
  .integrations-page-content.integrations-page-content {
    width: calc(100% - 28px);
    padding: 28px 0 64px;
  }

  .integrations-page-content .integrations-page-header {
    align-items: stretch;
    flex-direction: column;
    gap: 18px;
    margin-bottom: 34px;
  }

  .integrations-page-content .integrations-page-title {
    font-size: 25px;
  }

  .integrations-connected {
    margin-bottom: 38px;
  }

  .integrations-section-heading {
    margin-top: 42px;
  }

  .integrations-card {
    padding-right: 6px;
    padding-left: 6px;
  }

  .integrations-card-desc {
    -webkit-line-clamp: 3;
  }

}

@media (max-width: 480px) {
  .integrations-page-content .integrations-page-subtitle {
    font-size: 13px;
  }

  .integrations-card-logo {
    width: 40px;
    height: 40px;
    border-radius: 10px;
  }

  .integrations-account-list,
  .integrations-social-dropdown,
  .slack-agent-installation-list,
  .slack-agent-loading,
  .integrations-ad-status,
  .integrations-ad-empty,
  .integrations-ad-identity {
    margin-left: 52px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/IntegrationsPage.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,sBAAsB;EACtB,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;EAC9C,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,gDAAgD;EAChD,4CAA4C;EAC5C,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gFAAgF;EAChF,mBAAmB;EACnB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,kBAAkB;EAClB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,0DAA0D;AAC5D;;AAEA;EACE,4EAA4E;EAC5E,+EAA+E;AACjF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,2FAA2F;AAC7F;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uEAAuE;AACzE;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;;EAEE,kDAAkD;EAClD,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,6CAA6C;EAC7C,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,+EAA+E;EAC/E,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;IACE,oCAAoC;IACpC,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;AAEF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;;;;;;;IAOE,iBAAiB;EACnB;AACF","sourcesContent":[".integrations-page-content.integrations-page-content {\n  width: min(1060px, calc(100% - 56px));\n  min-height: 100%;\n  margin: 0 auto;\n  padding: 64px 0 96px;\n  box-sizing: border-box;\n  color: var(--color-text-primary);\n  background: var(--color-bg-root);\n}\n\n.integrations-page-content .integrations-page-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 28px;\n  margin-bottom: 46px;\n}\n\n.integrations-page-content .integrations-page-header-left {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.integrations-page-content .integrations-page-title {\n  margin: 0;\n  color: var(--color-text-primary);\n  font-size: 29px;\n  font-weight: 650;\n  line-height: 1.08;\n  letter-spacing: -0.04em;\n}\n\n.integrations-page-content .integrations-page-subtitle {\n  max-width: 560px;\n  margin: 0;\n  color: var(--color-text-secondary);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.integrations-error,\n.integrations-pending {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin: -24px 0 30px;\n  padding: 11px 14px;\n  border: 1px solid;\n  border-radius: 10px;\n  font-size: 12.5px;\n  line-height: 1.45;\n}\n\n.integrations-error {\n  border-color: var(--color-status-error-border);\n  background: var(--color-status-error-tint);\n  color: var(--color-status-error-text);\n}\n\n.integrations-pending {\n  border-color: var(--color-status-success-border);\n  background: var(--color-status-success-tint);\n  color: var(--color-status-success-text);\n}\n\n.integrations-connected {\n  margin-bottom: 46px;\n}\n\n.integrations-connected-heading {\n  display: flex;\n  align-items: baseline;\n  gap: 9px;\n  margin-bottom: 14px;\n}\n\n.integrations-connected-heading h2,\n.integrations-section-heading h2 {\n  margin: 0;\n  color: var(--color-text-primary);\n  font-size: 15px;\n  font-weight: 650;\n  letter-spacing: -0.01em;\n}\n\n.integrations-connected-heading span {\n  color: var(--color-text-secondary);\n  font-size: 11.5px;\n}\n\n.integrations-connected-list {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.integrations-connected-icon {\n  width: 42px;\n  height: 42px;\n  display: grid;\n  place-items: center;\n  border: 1px solid color-mix(in srgb, var(--color-border-input) 70%, transparent);\n  border-radius: 12px;\n  color: #fff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);\n}\n\n.integrations-section-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  margin: 50px 0 13px;\n}\n\n.integrations-section-heading--first {\n  margin-top: 0;\n}\n\n.integrations-section-heading > div:first-child {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.integrations-section-heading p {\n  margin: 0;\n  color: var(--color-text-secondary);\n  font-size: 12.5px;\n  line-height: 1.45;\n}\n\n.integrations-page-content .integrations-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  align-items: start;\n  gap: 8px 42px;\n  margin-top: 0;\n}\n\n.integrations-card {\n  min-width: 0;\n  padding: 13px 12px;\n  box-sizing: border-box;\n  border: 1px solid transparent;\n  border-radius: 12px;\n  background: transparent;\n  transition: border-color 150ms ease, background 150ms ease;\n}\n\n.integrations-card:hover {\n  border-color: color-mix(in srgb, var(--color-border-input) 62%, transparent);\n  background: color-mix(in srgb, var(--color-bg-canvas-surface) 66%, transparent);\n}\n\n.integrations-card-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 44px;\n}\n\n.integrations-card-summary {\n  min-width: 0;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1 1 auto;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.integrations-card-summary:disabled {\n  opacity: 1;\n  cursor: default;\n}\n\n.integrations-card-summary:focus-visible {\n  border-radius: 9px;\n  box-shadow: 0 0 0 3px var(--color-focus-ring);\n}\n\n.integrations-card-chevron {\n  flex: 0 0 auto;\n  color: var(--color-text-secondary);\n  transition: transform 180ms ease;\n}\n\n.integrations-card-chevron.is-expanded {\n  transform: rotate(180deg);\n}\n\n.integrations-card-logo {\n  position: relative;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  border-radius: 12px;\n  color: #fff;\n  box-sizing: border-box;\n}\n\n.integrations-card-logo-status {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  min-width: 19px;\n  height: 19px;\n  padding: 0 4px;\n  display: grid;\n  place-items: center;\n  box-sizing: border-box;\n  border: 2px solid var(--color-bg-root);\n  border-radius: 999px;\n  background: #e5484d;\n  color: #fff;\n  box-shadow: 0 1px 4px rgba(144, 18, 24, 0.28);\n  font-size: 10px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.integrations-card-logo--tiktok,\n.integrations-card-logo--x {\n  border: 1px solid #333;\n  background: #050505;\n}\n\n.integrations-card-logo--instagram {\n  background: linear-gradient(45deg, #f09433, #e6683c 25%, #dc2743 50%, #cc2366 75%, #8f24ba);\n}\n\n.integrations-card-logo--facebook {\n  background: #1877f2;\n}\n\n.integrations-card-logo--meta {\n  background: #0866ff;\n}\n\n.integrations-card-logo--youtube {\n  background: #ff0033;\n}\n\n.integrations-card-logo--slack {\n  border: 1px solid #dedede;\n  background: #fff;\n}\n\n.integrations-card-heading {\n  min-width: 0;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.integrations-card-title {\n  margin: 0;\n  overflow: hidden;\n  color: var(--color-text-primary);\n  font-size: 13.5px;\n  font-weight: 620;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.integrations-card-desc {\n  display: -webkit-box;\n  margin: 0;\n  overflow: hidden;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  line-height: 1.35;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n}\n\n.integrations-card-connect {\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  flex: 0 0 auto;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--color-text-primary);\n  font: inherit;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 150ms ease, color 150ms ease, opacity 150ms ease;\n}\n\n.integrations-card-connect:hover:not(:disabled) {\n  background: var(--color-bg-input);\n}\n\n.integrations-card-connect:disabled {\n  opacity: 0.42;\n  cursor: default;\n}\n\n.integrations-account-list,\n.slack-agent-installation-list {\n  display: flex;\n  flex-direction: column;\n  margin: 12px 0 0 56px;\n  border-top: 1px solid var(--color-border-sidebar);\n}\n\n.integrations-card-dropdown,\n.integrations-account-list--dropdown {\n  animation: integrations-dropdown-in 170ms ease-out;\n  transform-origin: top center;\n}\n\n.integrations-social-dropdown {\n  margin: 12px 0 0 56px;\n  border-top: 1px solid var(--color-border-sidebar);\n}\n\n.integrations-social-dropdown .integrations-account-list {\n  margin: 0;\n  border-top: 0;\n}\n\n.integrations-social-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 8px 2px;\n  border-bottom: 1px solid var(--color-border-sidebar);\n}\n\n.integrations-social-actions > span {\n  color: var(--color-text-secondary);\n  font-size: 10.5px;\n  font-weight: 600;\n}\n\n.integrations-social-actions button {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  border: 0;\n  background: transparent;\n  color: var(--color-text-secondary);\n  font: inherit;\n  font-size: 10.5px;\n  cursor: pointer;\n}\n\n.integrations-social-actions button:hover:not(:disabled) {\n  color: var(--color-text-primary);\n}\n\n.integrations-social-actions button:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n@keyframes integrations-dropdown-in {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.integrations-account-row,\n.slack-agent-installation-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  padding: 10px 2px;\n  border-bottom: 1px solid var(--color-border-sidebar);\n}\n\n.integrations-account-row:last-child,\n.slack-agent-installation-row:last-child {\n  border-bottom: 0;\n}\n\n.integrations-account-avatar {\n  width: 30px;\n  height: 30px;\n  flex: 0 0 auto;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.integrations-account-avatar--fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.integrations-account-info {\n  min-width: 0;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.integrations-account-username {\n  overflow: hidden;\n  color: var(--color-text-primary);\n  font-size: 12px;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.integrations-account-status {\n  color: var(--color-text-secondary);\n  font-size: 10.5px;\n}\n\n.integrations-account-status--connected {\n  color: var(--color-status-success-text);\n}\n\n.integrations-account-status--disconnected {\n  color: var(--color-status-error-text);\n}\n\n.integrations-account-status--warning {\n  color: #b76a00;\n}\n\n.integrations-account-remove {\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n}\n\n.integrations-account-remove:hover:not(:disabled) {\n  background: var(--color-status-error-tint);\n  color: var(--color-status-error-text);\n}\n\n.integrations-loading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 24px 12px;\n  color: var(--color-text-secondary);\n  font-size: 12.5px;\n}\n\n.slack-agent-card {\n  min-height: auto;\n}\n\n.slack-agent-card code {\n  padding: 2px 5px;\n  border-radius: 5px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 10.5px;\n}\n\n.integrations-ad-identity .integrations-card-connect,\n.integrations-ad-policy > .integrations-card-connect {\n  width: auto;\n  min-width: 34px;\n  padding: 0 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  background: var(--color-bg-canvas-surface);\n}\n\n.slack-agent-dropdown .slack-agent-installation-list {\n  margin: 0;\n  border-top: 0;\n}\n\n.integrations-ad-empty {\n  margin: 12px 0 0 56px;\n  color: var(--color-text-secondary);\n  font-size: 11.5px;\n  line-height: 1.45;\n}\n\n.slack-agent-loading {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin: 13px 0 0 56px;\n  color: var(--color-text-secondary);\n  font-size: 11.5px;\n}\n\n.slack-agent-installation-row {\n  justify-content: space-between;\n}\n\n.slack-agent-installation-main {\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.slack-agent-installation-main > div {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.slack-agent-installation-main strong {\n  color: var(--color-text-primary);\n  font-size: 12px;\n}\n\n.slack-agent-installation-main span {\n  font-size: 10.5px;\n}\n\n.slack-agent-workspace-avatar {\n  width: 30px;\n  height: 30px;\n  display: grid;\n  place-items: center;\n  flex: 0 0 auto;\n  border-radius: 50%;\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary) !important;\n  font-size: 12px !important;\n  font-weight: 800;\n}\n\n.slack-agent-installation-actions,\n.integrations-ad-status > div {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.slack-agent-installation-actions button,\n.integrations-ad-status button {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  border: 0;\n  background: transparent;\n  color: var(--color-text-secondary);\n  font: inherit;\n  font-size: 10.5px;\n  cursor: pointer;\n}\n\n.slack-agent-installation-actions button.is-danger,\n.integrations-ad-status button.is-danger {\n  color: var(--color-status-error-text);\n}\n\n.slack-agent-disconnect {\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  justify-content: center;\n  border-radius: 7px !important;\n}\n\n.slack-agent-disconnect:hover:not(:disabled) {\n  background: var(--color-status-error-tint);\n}\n\n.integrations-card--ads {\n  min-height: 70px;\n}\n\n.integrations-ad-status {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 12px 0 0 56px;\n  padding-top: 10px;\n  border-top: 1px solid var(--color-border-sidebar);\n}\n\n.integrations-ad-identity {\n  margin: 12px 0 0 56px;\n  color: var(--color-text-secondary);\n  font-size: 11px;\n}\n\n.integrations-ad-identity > summary {\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.integrations-ad-identity label {\n  display: grid;\n  gap: 4px;\n  margin-top: 9px;\n}\n\n.integrations-ad-identity input,\n.integrations-ad-policy__limits input {\n  min-height: 34px;\n  padding: 6px 9px;\n  box-sizing: border-box;\n  border: 1px solid var(--color-border-input);\n  border-radius: 7px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font: inherit;\n}\n\n.integrations-ad-identity .integrations-card-connect {\n  margin-top: 9px;\n}\n\n.integrations-ad-policy {\n  display: grid;\n  gap: 12px;\n  margin-top: 22px;\n  padding: 18px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--color-bg-canvas-surface) 72%, transparent);\n  color: var(--color-text-primary);\n}\n\n.integrations-ad-policy > div:first-child {\n  display: grid;\n  gap: 3px;\n}\n\n.integrations-ad-policy > div:first-child span,\n.integrations-ad-policy__limits label {\n  color: var(--color-text-secondary);\n  font-size: 11px;\n}\n\n.integrations-ad-policy__toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n}\n\n.integrations-ad-policy__limits {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\n  gap: 12px;\n}\n\n.integrations-ad-policy__limits > div,\n.integrations-ad-policy__limits label {\n  display: grid;\n  gap: 5px;\n}\n\n.integrations-ad-policy > .integrations-card-connect {\n  justify-self: start;\n}\n\n.integrations-spin {\n  animation: integrations-spin 0.9s linear infinite;\n}\n\n@keyframes integrations-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 900px) {\n  .integrations-page-content.integrations-page-content {\n    width: min(720px, calc(100% - 40px));\n    padding-top: 42px;\n  }\n\n  .integrations-page-content .integrations-grid {\n    grid-template-columns: 1fr;\n    gap: 6px;\n  }\n}\n\n@media (max-width: 700px) {\n  .integrations-page-content.integrations-page-content {\n    width: calc(100% - 28px);\n    padding: 28px 0 64px;\n  }\n\n  .integrations-page-content .integrations-page-header {\n    align-items: stretch;\n    flex-direction: column;\n    gap: 18px;\n    margin-bottom: 34px;\n  }\n\n  .integrations-page-content .integrations-page-title {\n    font-size: 25px;\n  }\n\n  .integrations-connected {\n    margin-bottom: 38px;\n  }\n\n  .integrations-section-heading {\n    margin-top: 42px;\n  }\n\n  .integrations-card {\n    padding-right: 6px;\n    padding-left: 6px;\n  }\n\n  .integrations-card-desc {\n    -webkit-line-clamp: 3;\n  }\n\n}\n\n@media (max-width: 480px) {\n  .integrations-page-content .integrations-page-subtitle {\n    font-size: 13px;\n  }\n\n  .integrations-card-logo {\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n  }\n\n  .integrations-account-list,\n  .integrations-social-dropdown,\n  .slack-agent-installation-list,\n  .slack-agent-loading,\n  .integrations-ad-status,\n  .integrations-ad-empty,\n  .integrations-ad-identity {\n    margin-left: 52px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
